import { useSelector } from 'react-redux';
import * as React from 'react';
import { RootState } from '../../reducers/reducers';
import OrganizationNavigator from '../OrganizationNavigator';
import InviteTeamModal from '../inviteTeam/InviteTeamModal';
import ChangeOrgModal from '../userSettings/ChangeOrgModal';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

const OrgNavigatorContainer: React.FC = () => {
    const location = useLocation();
    const history = useHistory();

    const [showInviteTeam, setShowInviteTeam] = React.useState(false);
    const [showChangeOrg, setShowChangeOrg] = React.useState(false);

    const orgId = useSelector((state: RootState) =>
        state.entities.orgs.allIds.length > 0 ? state.entities.orgs.allIds[0] : null,
    );

    const queryParams = qs.parse(location.search);
    const inviteModalShouldShow = queryParams['invite'];

    React.useEffect(() => {
        if (inviteModalShouldShow) {
            setShowInviteTeam(true);

            history.replace(location.pathname);
        }
    }, [inviteModalShouldShow]);

    return (
        <>
            {orgId && (
                <>
                    <InviteTeamModal open={showInviteTeam} onCancel={() => setShowInviteTeam(false)} orgId={orgId} />
                    <ChangeOrgModal
                        open={showChangeOrg}
                        currentOrgId={orgId}
                        onCancel={() => setShowChangeOrg(false)}
                        onSuccess={() => setShowChangeOrg(false)}
                    />
                </>
            )}
            <OrganizationNavigator
                onClickInviteTeam={() => setShowInviteTeam(true)}
                onClickChangeOrg={() => setShowChangeOrg(true)}
            />
        </>
    );
};

export default OrgNavigatorContainer;
